const taskTypes = {
  lectureOnline: 'online lecture',
  lectureOffline: 'offline lecture',
  // lecture_mixed: 'mixed lecture',
  // lecture_self_study: 'self study',
  // warmup: 'warm-up',
  jsTask: 'js task',
  // kotlintask: 'kotlin task',
  // objctask: 'objc task',
  htmltask: 'html task',
  codejam: 'code jam',
  externaltask: 'external task',
  codewars: 'codewars',
  // selfeducation: 'self education',
  default: 'not set',
}

export default taskTypes;